import { Fancybox } from "@fancyapps/ui";

document.addEventListener("DOMContentLoaded", function () {
    Fancybox.bind("[data-fancybox]", {
        dragToClose: false,
        Image: {
            zoom: false,
        },
    });
});